import { Component, ElementRef } from '@angular/core';
import { Router } from '@angular/router';
import { CommonModule } from '@angular/common';
import { MenuBarComponent } from '../../../core/components/menu-bar/menu-bar.component';
import { ImageCarouselComponent } from '../../../core/components/image-carousel/image-carousel.component';
import { FooterComponent } from '../../../core/components/footer/footer.component';
import { BackendService } from '../../../core/services/backend.service';
import { SolutionBase } from '../solution-base';
import { NgxTgModule } from '@worthy-ventures/metaglotta-ngx';

@Component({
  selector: 'app-solution-workspace',
  imports: [MenuBarComponent, CommonModule, ImageCarouselComponent, FooterComponent, NgxTgModule],
  templateUrl: './solution-workspace.component.html',
  styleUrl: './solution-workspace.component.scss'
})
export class SolutionWorkspaceComponent extends SolutionBase {
  constructor(router: Router, el: ElementRef, backendService: BackendService) {
    super(router, el, backendService);
  }
}
